import LoginPage from './Login.page';

export default LoginPage;
